module.exports = __webpack_public_path__ + "static/media/wateraid_3-min_h.a984fcb1.png";